import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import { RecipientSummaryListItem } from './RecipientSummaryListItem';
import { IFormUserRecipient } from '../../form-recipient-list/FormRecipientListUtils';

export type RecipientSummaryListProps = {
    title: string,
    items: IFormUserRecipient[],
};

export function RecipientSummaryList({
    items,
    title,
}: RecipientSummaryListProps) {
    
    return (
        <List
            dense
            component='nav'
            aria-labelledby="recipient-list-subheader"
            subheader={
                <ListSubheader id="recipient-list-subheader"
                    component='div' 
                    sx={{fontSize: '1.1rem'}} >
                        
                    {title}
                </ListSubheader>
            }>
                {items.map(o => 
                    <RecipientSummaryListItem key={o.userID} item={o} />
                )}
        </List>
      );
}
